import React from 'react';

import InputError from './InputError';

const RadioInput = (props) => (  
  <div className={props.name}>
    {props.title}
    <div className="checkbox-group">
      {props.options.map((opt, key) => {
        return (
          <div key={key}>
            <input
                className="form-checkbox"
                name={props.name}
                onChange={props.controlFunc}
                value={opt}
                id={opt}
                checked={ props.selectedOptions.indexOf(opt) > -1 }
                type="radio"/> 
            <label htmlFor={opt}><span><span></span></span>{opt}</label>
          </div>
        );
      })}
    </div>
    <InputError errorClass={props.validate} errorMessage={props.errorMessage}/>
  </div>
);

RadioInput.propTypes = {  
  title: React.PropTypes.string.isRequired,
  options: React.PropTypes.array.isRequired,
  selectedOptions: React.PropTypes.array,
  controlFunc: React.PropTypes.func.isRequired
};

export default RadioInput;  


// WEBPACK FOOTER //
// ./src/components/formComponents/RadioInput.js